import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconKeyComponent } from "./med-icon-key.component";

@NgModule({
  declarations: [
    MedIconKeyComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconKeyComponent,
  ],
})
export class MedIconKeyModule { }
